<!-- ErrorMessage.vue -->
<template>
    <transition name="fade">
      <div v-if="message" class="error-container">
        <div class="error-message">
          <span class="error-icon">⚠️</span>
          {{ message }}
          <button @click="dismiss" class="error-close">&times;</button>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    name: 'ErrorMessage',
    props: {
      message: {
        type: String,
        default: ''
      }
    },
    methods: {
      dismiss() {
        this.$emit('dismiss');
      }
    }
  }
  </script>
  
  <style scoped>
  .error-container {
    margin-top: 8px;
    margin-bottom: 8px;
    width: 100%;
  }
  
  .error-message {
    background-color: #FEE2E2;
    border: 1px solid #FCA5A5;
    color: #DC2626;
    padding: 12px 16px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    font-size: 14px;
  }
  
  .error-icon {
    margin-right: 8px;
  }
  
  .error-close {
    margin-left: auto;
    background: none;
    border: none;
    color: #DC2626;
    cursor: pointer;
    font-size: 18px;
    padding: 0 4px;
  }
  
  .error-close:hover {
    opacity: 0.7;
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
  }
  
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }
  </style>